import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Box, Grid, styled, Typography, useMediaQuery } from "@mui/material";
import Cookies from "js-cookie";
import { useTheme } from "@emotion/react";
import MessageMobile from "./MessageMobile";
import InfoDataBox from "./InfoDataBox";
import ChartLayout from "utilities/ChartLayout";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useJoyride } from "utilities/JoyrideProvider";

const BoxContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "open" && prop !== "theme",
})(({ theme }) => ({
  margin: "auto",
  marginTop: "2rem",
  marginBottom: "2rem",
  width: "90%",
  [theme.breakpoints.down("sm")]: {
    width: "327px",
  },
}));

const ProjectTab = ({ tabData, isLoadingTabs, compactProjectDetail, projectName }) => {
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const { setStepReadyState, stepReady } = useJoyride();
  const tour_completed = Cookies.get("tour_completed");

  let metrics = tabData?.content?.metrics;

  let charts = tabData.content?.charts;

  useEffect(() => {
    // Simulate data loading
    setStepReadyState(false);
    setTimeout(() => {
      if (!isLoadingTabs && tour_completed && stepReady) {
        // handleProjectPreviewClose();
        setStepReadyState(true); // Notify Joyride that the step is ready
      }
    }, 1000); // Adjust this delay to simulate your loading time
  }, [setStepReadyState, isLoadingTabs, stepReady, tour_completed]);


  return (
    <BoxContainer theme={theme}>
      <Grid
        container
        display="flex"
        justifyContent="space-between"
        alignItems="flex-start"
        flexDirection="column"
      >
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
          mb={3}
        >
          {metrics.map((data, idx) => (
            <InfoDataBox
              key={idx}
              infoindex={idx}
              infoData={data}
              infoName={tabData.name}
              compactProjectDetail={compactProjectDetail}
              forceGreenText={tabData.name === "ecosystem function"}
            />
          ))}

          {!isSmall ? (
            <>
              {charts.map((chartData, idx) => 
                  (
                    <Grid
                      key={idx}
                      item
                      sx={{ margin: "0.5rem 0", width: "100%" }}
                    >
                      <ChartLayout
                        tabDataName={tabData.name}
                        projectName={projectName}
                        chartData={chartData}
                      />
                    </Grid>
                  )
                )}
            </>
          ) : (
            <MessageMobile />
          )}

          {tabData.content?.tables && tabData.content?.tables.length > 0 && (
            <>
              {tabData.content?.tables.map((table, idx) => (
                <div key={idx} style={{ width: "100%" }}>
                  <Typography
                    variant="h4"
                    sx={{ color: "#2B2B2B", margin: "1rem 0rem" }}
                  >
                    {table.title}
                  </Typography>
                  <div style={{ width: "100%" }}>
                    <DataGrid
                      rows={table.rows}
                      columns={table.columns.map((r) => {
                        return { ...r, flex: 1 };
                      })}
                      autoHeight
                      initialState={{
                        density: "compact",
                        pagination: {
                          paginationModel: {
                            pageSize: 10,
                          },
                        },
                      }}
                      pageSizeOptions={[10, 50, 100]}
                      slots={{ toolbar: GridToolbar }}
                      sx={{
                        "& .MuiDataGrid-container--top [role=row]": {
                          background: "#e9e5da",
                        },
                      }}
                    />
                  </div>
                </div>
              ))}
            </>
          )}
        </Grid>
      </Grid>
    </BoxContainer>
  );
}

ProjectTab.propTypes = {
  tabData: PropTypes.object,
  isLoadingTabs: PropTypes.bool,
  compactProjectDetail: PropTypes.bool,
  projectName: PropTypes.string,
};

export default ProjectTab;
